<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'integrasi',
    message: 'Saya tertarik dengan plugin Shopify KiriminAja'
  }
})

const route = useRoute()

const { data } = await useAsyncData(`shopify-${route.path}`, () =>
  queryCollection('shopify')
    .path(`/shopify/${route.params.slug?.toString()}`)
    .first()
)

if (!data.value || !route.params.slug) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page not found'
  })
}

const courier = computed(() =>
  getCourierProps(route.params.slug?.toString() || '')
)
useDefaultMeta({
  title: data.value?.meta?.title || data.value.title,
  description: data.value.meta?.description || data.value.description,
  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    breadcrumbs: [
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Plugin Shopify',
        item: appUrl('/solusi-plugin-shopify')
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: courier.value?.courier || 'Plugin Shopify',
        item: appUrl(route.fullPath)
      }
    ]
  }
})
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      :title="data?.title"
      :description="data?.description"
      hero-image="/images/plugin-shopify-banner-1.webp"
    >
      <template v-if="courier" #above-title>
        <div class="flex gap-3 items-center">
          <UiCourierService
            class="h-6 aspect-video"
            :icon="courier?.icon"
            icon-size="40px"
            :class="courier.class"
          />
          <div class="grow font-semibold">
            {{ courier.courier }}
          </div>
        </div>
      </template>
      <template #action>
        <div class="flex items-center gap-2 lg:gap-4 py-2">
          <UiButton
            to="https://apps.shopify.com/kiriminaja"
            label="Install Plugin"
            target="_blank"
            icon="material-symbols:download"
          />
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Hubungi Kami"
            variant="primaryOutline"
            icon="material-symbols:call-outline"
          />
        </div>
      </template>
    </HeroBase>

    <SolusiPluginShopifyFiturDashboard
      :title="data?.benefit.title"
      :items="data?.benefit.items ?? []"
    />
    <SolusiPluginShopifyCaraInstall
      :title="data?.workflow.title"
      :items="
        data?.workflow.steps?.map((item) => ({
          title: item
        }))
      "
    />
    <SolusiPluginShopifyFiturDisukai
      :title="data?.target.title"
      :items="data?.target.items"
    />
    <PresetCourier
      title="Semua Ekspedisi Favoritmu, Siap di Shopify - KiriminAja"
      path="/solusi/plugin-shopify"
    />
    <FaqBase :title="data?.faq?.title" :faqs="data?.faq?.items ?? []" />
    <SolusiPluginShopifyCta :title="data?.cta.title" />
  </div>
</template>
